module.exports = __webpack_public_path__ + "static/media/bg.557c1fd7.jpg";